export default function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
}



//////////////////
// WEBPACK FOOTER
// /Users/danielcorrea/Documents/Workshops/d3Angulr/angular-d3-example/~/d3-interpolate/src/round.js
// module id = ../../../../d3-interpolate/src/round.js
// module chunks = 3